/**
 * Donation form handler for headlines/read page
 */

(function() {
    'use strict';

    const donationForm = document.getElementById('donation-form');

    if(!donationForm) {
        return;
    }

    const anonymousCheck    = document.getElementById('anonymousCheck');
    const personFields      = document.getElementById('person-fields');
    const amountButtons     = document.querySelectorAll('input[name="amount_choice"]');
    const customAmountGroup = document.getElementById('customAmountGroup');
    const customAmountInput = document.getElementById('customAmount');
    const amountHiddenField = document.getElementById('amount');
    const errorDiv          = document.getElementById('donation-error');

    // Toggle person fields based on anonymous checkbox
    anonymousCheck.addEventListener('change', function() {
        if(this.checked) {
            personFields.style.display = 'none';
            // Remove required attributes when anonymous
            document.getElementById('firstName').removeAttribute('required');
            document.getElementById('lastName').removeAttribute('required');
            document.getElementById('email').removeAttribute('required');
        } else {
            personFields.style.display = 'block';
            // Re-add required attributes
            document.getElementById('firstName').setAttribute('required', 'required');
            document.getElementById('lastName').setAttribute('required', 'required');
            document.getElementById('email').setAttribute('required', 'required');
        }
    });

    // Handle amount button selection
    amountButtons.forEach(function(radio) {
        // Listen on the parent label element for clicks (Bootstrap button group behavior)
        const label = radio.closest('label');
        if(label) {
            label.addEventListener('click', function(e) {
                // Let the radio button get checked naturally, then update our hidden field
                setTimeout(function() {
                    const selectedRadio = document.querySelector('input[name="amount_choice"]:checked');
                    if(selectedRadio) {
                        if(selectedRadio.value === 'custom') {
                            customAmountGroup.style.display = 'block';
                            customAmountInput.setAttribute('required', 'required');
                            amountHiddenField.value = customAmountInput.value || '';
                        } else {
                            customAmountGroup.style.display = 'none';
                            customAmountInput.removeAttribute('required');
                            amountHiddenField.value = selectedRadio.value;
                        }
                    }
                }, 10);
            });
        }

        // Also keep change event as backup
        radio.addEventListener('change', function() {
            if(this.value === 'custom') {
                customAmountGroup.style.display = 'block';
                customAmountInput.setAttribute('required', 'required');
                amountHiddenField.value = customAmountInput.value || '';
            } else {
                customAmountGroup.style.display = 'none';
                customAmountInput.removeAttribute('required');
                amountHiddenField.value = this.value;
            }
        });
    });

    // Update hidden amount field when custom amount changes
    if(customAmountInput) {
        customAmountInput.addEventListener('input', function() {
            amountHiddenField.value = this.value;
        });
    }

    // Form submission
    donationForm.addEventListener('submit', function(e) {
        e.preventDefault();

        // Validate amount is set
        if(!amountHiddenField.value || parseFloat(amountHiddenField.value) < 1) {
            showError('Selecteer een bedrag of vul een geldig bedrag in.');
            return;
        }

        // Get submit button
        const submitButton       = this.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.textContent;
        submitButton.disabled    = true;
        submitButton.textContent = 'Verwerken...';

        // Hide any previous errors
        hideError();

        // Collect form data
        const formData = new FormData(this);

        // Create XMLHttpRequest
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/donation', true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('Accept', 'application/json');

        xhr.onload = function() {
            if(xhr.status >= 200 && xhr.status < 300) {
                const response = JSON.parse(xhr.responseText);

                if(response.success && response.checkout_url) {
                    // Redirect to Mollie checkout
                    window.location.href = response.checkout_url;
                } else {
                    showError('Er is iets misgegaan. Probeer het opnieuw.');
                    submitButton.disabled    = false;
                    submitButton.textContent = originalButtonText;
                }
            } else {
                let errorMessage = 'Er is een fout opgetreden.';
                try {
                    const response = JSON.parse(xhr.responseText);
                    if(response.message) {
                        errorMessage = response.message;
                    } else if(response.errors) {
                        // Laravel validation errors
                        const errors = Object.values(response.errors).flat();
                        errorMessage = errors.join('<br>');
                    }
                } catch(e) {
                    // Keep default error message
                }
                showError(errorMessage);
                submitButton.disabled    = false;
                submitButton.textContent = originalButtonText;
            }
        };

        xhr.onerror = function() {
            showError('Er is een netwerkfout opgetreden.');
            submitButton.disabled    = false;
            submitButton.textContent = originalButtonText;
        };

        xhr.send(formData);
    });

    function showError(message) {
        errorDiv.innerHTML     = message;
        errorDiv.style.display = 'block';
        errorDiv.scrollIntoView({behavior: 'smooth', block: 'center'});
    }

    function hideError() {
        errorDiv.style.display = 'none';
    }
})();

